import type { Action } from "./Action";
import type { ContentType } from "./ContentType";
import type { Content } from "./Content";
import type { Project } from "./Project";
import type { IMedia } from "../../../../model/unityObject";
import type { IProjectLanguageData } from "src/model/model";

export type WireContentType = ContentType | { modelName: string; object?: undefined };

export const hasContentTypeObject = (contentType: WireContentType): contentType is ContentType =>
  contentType?.object != null;

export type FlatGraphResponse = {
  project: Project;
  contents: Content[];
  contentTypes: WireContentType[];
  actions: Action[];
  errorMessages: string[];
  warningMessages?: { error: string; details?: { unlinkedScenesIds?: number[] } }[];
  sourceMedias?: IMedia[];
  projectLanguageDatas?: IProjectLanguageData[];
};
